import { ReactElement } from "react";

interface IGeneralLayoutProps {
  children?: ReactElement;
  subTitle?: string | null;
  CurrentPage?: string | null;
}

function GeneralLayoutWithDots({
  children,
  subTitle,
  CurrentPage,
}: IGeneralLayoutProps): ReactElement {

  return (
    <>
      <main id="content-container" className="">

        <section className={`flex flex-row overflow-hidden pb-20`}>
          <div className="w-full bg-white z-10 flex flex-col gap-y-10 h-full pb-12 white-page-layout-content">
            {subTitle ? (
              <div className="bg-primary bg-dots pt-[80px] pb-[70px] flex flex-col justify-center">
                <p className="title-underline section-title">
                  {subTitle}
                </p>

                <div className="container mx-auto px-4">
                  <ul className="about-menu">
                    {CurrentPage !== "AboutUs" && (
                      <li>
                        <a href="/aboutus">About Us</a>
                      </li>
                    )}
                    {CurrentPage !== "Benefits" && (
                        <li>
                            <a href="/benefits">Benefits</a>
                        </li>
                    )}
                    {CurrentPage !== "Objectives" && (
                      <li>
                        <a href="/objectives">Objectives</a>
                      </li>
                    )}
                    {CurrentPage !== "Board" && (
                        <li>
                            <a href="/board">Board</a>
                        </li>
                    )}
                    {CurrentPage !== "Council" && (
                        <li>
                            <a href="/councils">Councils</a>
                        </li>
                    )}
                    {CurrentPage !== "Members" && (
                        <li>
                            <a href="/wsg_members.asp">Members</a>
                        </li>
                    )}
                    {CurrentPage !== "Join" && (
                        <li>
                            <a href="/join">Join</a>
                        </li>
                    )}
                  </ul>
                </div>
              </div>
            ) : null}

            {children}
            <div className="flex flex-row gap-x-2 mt-0 px-10">
              {Array.from({ length: 3 }, (_, i) => (
                <div
                  key={i}
                  className="bg-[#bc3323] rounded-full w-6 h-6"
                ></div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default GeneralLayoutWithDots;
